import type { Theme } from '@mui/material';

export const styles = {
  tableHeaderCell: (theme: Theme) => ({
    pt: 1,
    pb: 0.5,
    ...theme.typography.body3,
    fontWeight: 600,
    color: theme.colors.neutral[700],
    borderColor: theme.colors.neutral[100],
    backgroundColor: theme.colors.neutral[50],
    wordWrap: 'break-word',

    '&:first-of-type': {
      pl: 1,
    },

    '&:last-of-type': {
      pr: 0,
    },
  }),

  tableHeadline: {
    justifyContent: 'center',
    cursor: 'pointer',
  },
};
